import { createFileRoute } from "@tanstack/react-router";
import { ConnectPage } from "../screens/data/ConnectPage.tsx";

/** `/connect#<token>`: the developer's connect page (no account, no app shell). */
export const Route = createFileRoute("/connect")({
  component: ConnectPage,
});
